import { Component, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Subject } from 'rxjs';
import { Rule, Stage } from '../../../../../models/rule.model';
import { CriticalityLevel } from '../../../../../../enum/criticality-level.enum';
import { criticalityOptions } from '../../../../constants/criticality-option.constans';
import { stageOptions } from '../../../../constants/stage-options.constant';
import { FILTER_VALUE } from '../../../../constants/filters.constants';
import { RoleService } from '@ind4.0/angular-common-lib';

@Component({
  selector: 'app-parameters-step',
  templateUrl: './parameters-step.component.html',
  standalone: false,
})
export class ParametersStepComponent implements OnInit, OnDestroy {
  @Input() formGroup!: FormGroup;
  @Input() rule?: Rule;
  @Input() mode: 'create' | 'edit' = 'edit';
  @Input() prodStageValidationMessage: string = '';

  private roleService = inject(RoleService);
  private destroy$ = new Subject<void>();

  criticalityOptions: SelectItem[] = criticalityOptions;
  stageOptions: SelectItem[] = [];

  stateOptions: SelectItem[] = [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ];

  get hasActiveEvaluation(): boolean {
    if (
      !this.rule?.latestAlarm ||
      this.rule?.latestAlarm.status == 0 ||
      !this.rule.latestAlarm.evaluation
    ) {
      return false;
    }
    return this.rule.latestAlarm.evaluation.isFinal === false;
  }

  get stageTooltipMessage(): string {
    if (this.hasActiveEvaluation) {
      return "La maturité d'une règle ne peut être changé lorsqu'une évaluation d'alerte est en cours";
    }
    return '';
  }

  get hasErrors(): boolean {
    const fields = [
      'context',
      'behaviorSummary',
      'weeksBeforeFailure',
      'stage',
      'criticality',
      'isActive',
    ];
    return fields.some((f) => {
      const ctrl = this.formGroup.get(f);
      return ctrl && ctrl.invalid && ctrl.touched;
    });
  }

  ngOnInit(): void {
    this.stageOptions = this.getStageOptions();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getStageOptions(): SelectItem[] {
    const baseOptions = stageOptions.filter(
      (option) => option.value !== FILTER_VALUE.ALL,
    );
    if (this.mode === 'create') {
      return baseOptions.filter((option) => option.value === Stage.Dev);
    }
    if (this.roleService.hasRole('SED_PLUS_ADMIN')) {
      return baseOptions;
    }
    if (this.roleService.hasRole('SED_PLUS_SUPER_USER')) {
      return baseOptions.filter(
        (option) => option.value === Stage.Dev || option.value === Stage.Qa,
      );
    }
    return baseOptions.filter(
      (option) => option.value === Stage.Dev || option.value === Stage.Qa,
    );
  }

  getFieldError(fieldName: string): string | null {
    const control = this.formGroup.get(fieldName);
    if (!control || !control.invalid || !control.touched) return null;
    const errors = control.errors;
    if (!errors) return null;
    if (errors['required']) return 'Ce champ est requis';
    if (errors['invalidCriticality']) return 'Criticité invalide';
    return 'Valeur invalide';
  }
}
